// English is the app's LTR locale; unsupported/missing locales retain the
// Hebrew fallback used by useShortLocale and the translation provider.
export const getLocaleDirection = (locale?: string): "ltr" | "rtl" =>
  locale?.split("-")[0].toLowerCase() === "en" ? "ltr" : "rtl";
